export default {
      id: "duration-24-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/iconset.svg#duration-24",
      toString: function () {
        return this.url;
      }
    }